import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { IconContainer } from "../IconContainer.mjs";
import { IconRedoSvg } from "./IconRedoSvg.mjs";
const IconRedo = (props) => /* @__PURE__ */ jsx(IconContainer, { ...props, children: (svgProps) => /* @__PURE__ */ jsx(Box, { component: IconRedoSvg, ...svgProps }) });
export {
  IconRedo
};
